export const appConfig = {
	isLocalMode: import.meta.env.DEV,
	environment: import.meta.env.VITE_BREET_ENV,
	isDevMode: import.meta.env.VITE_BREET_ENV === 'development',
	baseApiUrl: import.meta.env.VITE_BASE_API_URL,
	sentry: {
		dsn: import.meta.env.VITE_SENTRY_DSN,
		enabled: import.meta.env.VITE_IS_SENTRY_ENABLED?.toString() === 'true',
		project: import.meta.env.VITE_SENTRY_PROJECT,
	},
};
